export enum ITrackTypes {
  eTracks = 'E-tracks',
  verticalTracks = 'Vertical Tracks',
}

export enum IRoofTypes {
  nonTranslucentRoof = 'Non-Translucent Roof',
  metalRoof = 'Metal Roof',
}

export enum IDoorTypes {
  swingDoors = 'Swing Doors',
  rollDoors = 'Roll Doors',
}

export enum IWallTypes {
  woodWalls = 'Wood Walls',
  fiberglassWalls = 'Fiberglass Walls',
}

export enum IFloorTypes {
  metalFloor = 'Metal Floor',
  woodFloor = 'Wood Floor',
  dRingFloor = 'D-Ring Floor',
}

export enum IReeferTempControlTypes {
  fixed = 'Fixed',
  range = 'Range',
}

export enum IReeferFlowTypes {
  continuous = `Cont'`,
  startStop = 'Start/Stop',
}

export enum IReeferDownloadableReportTypes {
  yes = 'Yes',
  no = 'No',
}
